import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=6ba96efc&scoped=true"
var script = {}
import style0 from "./Header.vue?vue&type=style&index=0&id=6ba96efc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba96efc",
  null
  
)

export default component.exports